import { Form, Input } from "antd";

export default () => {
  return (
    <Form.Item label="Section ID" name="contentID">
      <Input />
    </Form.Item>
  );
};
